import { fetchJson } from './fetchUtils';

export const fetchIsLoggedIn = async () => {
  const res = await fetchJson('/api/user/isLoggedIn');
  return res.isLoggedIn;
};

export const fetchCurrentUser = async () => {
  const res = await fetchJson('/api/user/getCurrentUser');
  return res.currentUser;
};

export const fetchSubscribeInfo = async () => {
  const res = await fetchJson('/api/subscribe/subscribeInfo');
  return res.subscribeInfo;
};

export const fetchStripeApiKey = async () => {
  const res = await fetchJson('/api/subscribe/getStripeApiKey');
  return res.stripeApiKey;
};

export const fetchEnvironment = async () => {
  const res = await fetchJson('/api/user/getEnvironment');
  return res.environmentName;
};
